import { ValueFormatterParams } from "ag-grid-community";
import React, { useCallback, useRef, useState } from "react";
import PlusButtonIcon from "../../../../assets/images/PlusButtonIcon.svg";
import Grid from "../../../../components/Grid";
import { ColumnDef } from "../../../../components/Grid/model/Grid";
import ModalDelete from "../../../../components/ModalDelete";
import Loading from "../../../../core/common/Loading";
import { formatDateTimeBR, maskCnpj } from "../../../../helpers/format";
import { useModal } from "../../../../hooks/ModalContext";
import api from "../../../../services/api";
import CreateMensalista from "./Create";
import Info from "./Info";
import { IMensalista } from "./types/types";
import ModalHistory from "../../../../components/ModalHistory";
import Can from "../../../../components/Can";

// import { Container } from './styles';

const ListMensalista: React.FC = () => {
  const [columns] = useState<ColumnDef[]>([
    {
      field: "placa",
      headerName: "Placa",
      filter: true,
      valueFormatter: (params: ValueFormatterParams) => {
        if (params.value) {
          return params.value.toUpperCase();
        }
        return "---";
      },
    },
    {
      field: "cnpj",
      headerName: "CNPJ Avulso",
      filter: true,
      width: 300,
      valueFormatter: (params: ValueFormatterParams) => {
        if (params.value) {
          return maskCnpj(params.value);
        }
        return "---";
      },
    },
    {
      field: "mensalista_transportadora.razao_social_transportadora",
      headerName: "Razão Social",
      filter: true,
      width: 300,
      valueFormatter: (params: ValueFormatterParams) => {
        if (params.value) {
          return params.value;
        }
        return "---";
      },
    },
    {
      field: "usuario",
      headerName: "Usuário",
      filter: true,
      valueFormatter: (params: ValueFormatterParams) => {
        if (params.value) {
          return params.value;
        }
        return "---";
      },
    },
    {
      field: "data_historico",
      headerName: "Data Modificação",
      valueFormatter: (params: ValueFormatterParams) => {
        if (params.value) {
          return formatDateTimeBR(params.value);
        }
      },
    },
  ]);
  const [selectedRow, setSelectedRow] = useState<IMensalista>();
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [isView, setIsView] = useState<boolean>(false);
  const [isRemove, setIsRemove] = useState<boolean>(false);
  const [isHistory, setIsHistory] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const gridRef = useRef<any>(null);
  const { isModalOpen, closeModal, openModal } = useModal();

  const onDelete = useCallback(async (entityId?: number) => {
    try {
      setLoading(true);

      const body = {
        id_mensalista: entityId,
      };

      await api.post("/deletar/mensalistas", body);

      setLoading(false);

      setIsRemove(false);

      gridRef.current?.refresh();
    } catch {
      setLoading(false);
    }
  }, []);

  return (
    <>
      <Loading loading={loading} />
      {isModalOpen && (
        <CreateMensalista
          isView={isView}
          isEdit={isEdit}
          selectedRow={selectedRow}
          onClear={() => closeModal()}
          onConfirm={() => {
            closeModal();
            gridRef.current?.refresh();
          }}
        />
      )}
      {isRemove && (
        <ModalDelete
          onCancel={() => setIsRemove(!isRemove)}
          onConfirm={() => onDelete(selectedRow?.id_mensalista)}
          row={selectedRow?.placa}
        />
      )}

      {isView && (
        <Info data={selectedRow} title="Conhecer - Mensalista" onClose={() => setIsView(!isView)} />
      )}

      {isHistory && selectedRow && (
        <ModalHistory
          isOpen={isHistory}
          title="Histórico - Mensalistas"
          historyRoute="/historico/mensalistas"
          bodyKey="id_mensalista"
          bodyValue={selectedRow.id_mensalista}
          onClose={() => setIsHistory(false)}
        />
      )}

      <div className="flex flex-col w-full h-screen bg-[#F5F5F5] p-5">
        <div className="flex items-center justify-between w-full mb-3">
          <div>
            <h1 className="text-2xl text-[#000000] font-bold">Mensalista</h1>
          </div>
          <div className="mr-14">
            <Can acao="SALVAR">
            <button
              className="flex items-center justify-center h-12 w-36 bg-[#062D4E] text-[#FFFFFF] text-sm font-light border-none rounded-full"
              onClick={() => {
                openModal()
              }}
              id="btnCreate"
            >
              Adicionar <img src={PlusButtonIcon} alt="" className="ml-2" />
            </button>
            </Can>
          </div>
        </div>
        <div className="flex w-full">
          <Grid
            ref={gridRef}
            columns={columns}
            filters={[]}
            pagination
            path="/listar/mensalistas"
            onUpdate={(data: any) => {
              setSelectedRow(data);
              setIsEdit(!isEdit);
              openModal();
            }}
            onDelete={(data: any) => {
              setIsRemove(!isRemove);
              setSelectedRow(data);
            }}
            onView={(data: any) => {
              setSelectedRow(data);
              setIsView(!isView);
            }}
            onHistory={(data: any) => {
              setSelectedRow(data);
              setIsHistory(true);
            }}
            status={[]}
          />
        </div>
      </div>
    </>
  );
};

export default ListMensalista;

